export default async function trackGrowthBookExperimentDetails(fromRedirectUrl, heapTrackingCallback, experiment = {}, result = {}, isSplitUrlTest = false, timeTakenToDecideBucketFromPageLoad = null, timeTakenToDecideBucketFromGBInit = null, timeTakenFromPageLoadToGBScriptReady = null, timeTakenToDownloadGBScript = null) {
	if (fromRedirectUrl) {
		const growthbookVariationDetails = sessionStorage.getItem('growthbookVariationDetails');
		if (growthbookVariationDetails) {
			const details = JSON.parse(growthbookVariationDetails);
			experiment = details.experiment;
			result = details.result;
			timeTakenToDecideBucketFromPageLoad = details.timeTakenToDecideBucketFromPageLoad;
			timeTakenToDecideBucketFromGBInit = details.timeTakenToDecideBucketFromGBInit;
			timeTakenFromPageLoadToGBScriptReady = details.timeTakenFromPageLoadToGBScriptReady;
			timeTakenToDownloadGBScript = details.timeTakenToDownloadGBScript;
		}
	}

	const variationFromResult = fromRedirectUrl || isSplitUrlTest ? result.name : result.value;
	const variationName = typeof variationFromResult === 'string' && variationFromResult.includes(' ') ? variationFromResult.replace(/\s+/g, '-') : variationFromResult;

	const trackingInfo = {
		experimentId: experiment.key,
		variationName: variationName,
		// Time from page start until GrowthBook did bucket assignment (ms).
		timeTakenToDecideBucketFromPageLoad: timeTakenToDecideBucketFromPageLoad,
		// Time from GrowthBook init to bucket assignment (control/variation).
		timeTakenToDecideBucketFromGBInit: timeTakenToDecideBucketFromGBInit,
		// Time from page start until growthbook.min.js finished loading and running.
		timeTakenFromPageLoadToGBScriptReady: timeTakenFromPageLoadToGBScriptReady,
		// Time for the browser to download growthbook.min.js over the network.
		timeTakenToDownloadGBScript: timeTakenToDownloadGBScript
	};

	window.activeCampaignData = {
		'Test ID': experiment.key,
		'Variation Name': variationName
	};

	const triggerHeapEvents = function() {
		window.Modalytics.heap('track', ['Viewed Growthbook Experiment', trackingInfo]);
		window.Modalytics.heap('addUserProperties', window.activeCampaignData);
		window.Modalytics.heap('addEventProperties', window.activeCampaignData);
		if (!experiment.key && fromRedirectUrl) {
			window.Modalytics.heap('track', ['GB session storage item for tracking variation is not available']);
		}

		if (heapTrackingCallback && typeof heapTrackingCallback === 'function') {
			heapTrackingCallback();
		}
	};

	if (window.heap) {
		triggerHeapEvents();
	} else {
		document.addEventListener('heap.loaded', function() {
			triggerHeapEvents();
		});
	}
}
